import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-hud',
    templateUrl: './hud.component.html',
    styleUrls: ['./hud.component.scss'],
    standalone: true,
    imports: [FaIconComponent, NgIf]
})
export class HudComponent implements OnChanges {

  @Input()
  pointsEarned?: number ;

  @Input()
  pointsOffered?: number ;


  health?: number ;
  armour?: number ;


  ngOnChanges(changes: SimpleChanges): void {


    if (this.pointsEarned === undefined || !this.pointsOffered) {
      this.health = undefined;
      this.armour = undefined;

      return;
    }

    if (this.pointsEarned < this.pointsOffered) {
      this.health = Math.round((this.pointsEarned / this.pointsOffered) * 100);
      this.armour = 0;
    } else {

      this.health = 100;
      this.armour = this.pointsEarned - this.pointsOffered;
    }
  }

  get hasScore(): boolean {
    return this.health != undefined ;
  }

  get healthClass(): string {

    if (this.health == undefined) {
      return 'text-muted'
    } else {
      return '';
    }

    /*
    if (this.health < 100) {
      return 'text-negative'
    } else {
      return 'text-positive'
    }*/
  }

  get armourClass(): string {
    if (!this.armour) {
      return 'text-muted'
    } else {
      return 'text-yellow-200'
    }
  }





}
